import { useContext } from 'react'
import OnboardingContext from './OnboardingContext'

export default function useOnboarding() {
  return useContext(OnboardingContext)
}
